var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bldg_name)?_c('p',{staticClass:"ml-2"},[_c('NETVSIcon',{attrs:{"icon":"building"}}),_vm._v(" "+_vm._s(_vm.bldg_name)+" "),(_vm.room_name)?[_c('br'),_vm._v("└─ "),_c('NETVSIcon',{attrs:{"icon":"room"}}),_vm._v(" "+_vm._s(_vm.room_name)+" ")]:_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }